import React, { useState } from 'react';
import { Button } from '../shared/Button';
interface NotificationsScreenProps {
  navigateTo: (screen: string) => void;
  onBack: () => void;
}
export const NotificationsScreen = ({
  navigateTo,
  onBack
}: NotificationsScreenProps) => {
  const [frequency, setFrequency] = useState('daily');
  const [timing, setTiming] = useState('morning');
  const [tone, setTone] = useState('gentle');
  const handleSaveChanges = () => {
    // Here you would save the notification preferences
    // For now, we'll just go back to the profile page
    onBack();
  };
  return <div className="flex flex-col h-full min-h-screen bg-white" data-id="element-1163">
      <div className="p-6" data-id="element-1164">
        <button onClick={onBack} className="text-gray-500 mb-4" data-id="element-1165">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1166">
            <path d="m12 19-7-7 7-7" data-id="element-1167"></path>
            <path d="M19 12H5" data-id="element-1168"></path>
          </svg>
        </button>
        <h1 className="text-xl font-bold text-center mb-2" data-id="element-1169">Reminders</h1>
      </div>
      <main className="flex-1 px-6 pb-6 space-y-8" data-id="element-1170">
        <div className="text-center" data-id="element-1171">
          <h2 className="text-2xl font-bold mb-2" data-id="element-1172">Reminders, your way</h2>
          <div className="flex justify-center mb-2" data-id="element-1173">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-yellow-400" data-id="element-1174">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" data-id="element-1175"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0" data-id="element-1176"></path>
            </svg>
          </div>
          <p className="text-gray-500" data-id="element-1177">
            Choose when and how you'd like us to nudge you. You're always in
            control.
          </p>
        </div>
        <div className="space-y-4" data-id="element-1178">
          <h3 className="font-medium text-lg" data-id="element-1179">Frequency</h3>
          <div className={`p-4 rounded-xl border ${frequency === 'daily' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setFrequency('daily')} data-id="element-1180">
            <div className="flex justify-between items-center" data-id="element-1181">
              <div data-id="element-1182">
                <h4 className="font-medium" data-id="element-1183">Daily</h4>
                <p className="text-gray-500 text-sm" data-id="element-1184">
                  Get a daily reminder to stay on track.
                </p>
              </div>
              <div className={`w-6 h-6 rounded-full ${frequency === 'daily' ? 'bg-blue-500' : 'border border-gray-300'} flex items-center justify-center`} data-id="element-1185">
                {frequency === 'daily' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1186">
                    <path d="M20 6 9 17l-5-5" data-id="element-1187"></path>
                  </svg>}
              </div>
            </div>
          </div>
          <div className={`p-4 rounded-xl border ${frequency === 'weekly' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setFrequency('weekly')} data-id="element-1188">
            <div className="flex justify-between items-center" data-id="element-1189">
              <div data-id="element-1190">
                <h4 className="font-medium" data-id="element-1191">Weekly</h4>
                <p className="text-gray-500 text-sm" data-id="element-1192">
                  Receive a weekly reminder to review your progress.
                </p>
              </div>
              <div className={`w-6 h-6 rounded-full ${frequency === 'weekly' ? 'bg-blue-500' : 'border border-gray-300'} flex items-center justify-center`} data-id="element-1193">
                {frequency === 'weekly' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1194">
                    <path d="M20 6 9 17l-5-5" data-id="element-1195"></path>
                  </svg>}
              </div>
            </div>
          </div>
          <div className={`p-4 rounded-xl border ${frequency === 'custom' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setFrequency('custom')} data-id="element-1196">
            <div className="flex justify-between items-center" data-id="element-1197">
              <div data-id="element-1198">
                <h4 className="font-medium" data-id="element-1199">Custom</h4>
                <p className="text-gray-500 text-sm" data-id="element-1200">
                  Set a personalized reminder schedule.
                </p>
              </div>
              <div className={`w-6 h-6 rounded-full ${frequency === 'custom' ? 'bg-blue-500' : 'border border-gray-300'} flex items-center justify-center`} data-id="element-1201">
                {frequency === 'custom' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1202">
                    <path d="M20 6 9 17l-5-5" data-id="element-1203"></path>
                  </svg>}
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1204">
          <h3 className="font-medium text-lg" data-id="element-1205">Timing</h3>
          <div className={`p-4 rounded-xl border ${timing === 'morning' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setTiming('morning')} data-id="element-1206">
            <div className="flex justify-between items-center" data-id="element-1207">
              <div data-id="element-1208">
                <h4 className="font-medium" data-id="element-1209">Morning</h4>
                <p className="text-gray-500 text-sm" data-id="element-1210">
                  Receive your reminder in the morning.
                </p>
              </div>
              <div className={`w-6 h-6 rounded-full ${timing === 'morning' ? 'bg-blue-500' : 'border border-gray-300'} flex items-center justify-center`} data-id="element-1211">
                {timing === 'morning' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1212">
                    <path d="M20 6 9 17l-5-5" data-id="element-1213"></path>
                  </svg>}
              </div>
            </div>
          </div>
          <div className={`p-4 rounded-xl border ${timing === 'midday' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setTiming('midday')} data-id="element-1214">
            <div className="flex justify-between items-center" data-id="element-1215">
              <div data-id="element-1216">
                <h4 className="font-medium" data-id="element-1217">Midday</h4>
                <p className="text-gray-500 text-sm" data-id="element-1218">
                  Get your reminder around midday.
                </p>
              </div>
              <div className={`w-6 h-6 rounded-full ${timing === 'midday' ? 'bg-blue-500' : 'border border-gray-300'} flex items-center justify-center`} data-id="element-1219">
                {timing === 'midday' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1220">
                    <path d="M20 6 9 17l-5-5" data-id="element-1221"></path>
                  </svg>}
              </div>
            </div>
          </div>
          <div className={`p-4 rounded-xl border ${timing === 'evening' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`} onClick={() => setTiming('evening')} data-id="element-1222">
            <div className="flex justify-between items-center" data-id="element-1223">
              <div data-id="element-1224">
                <h4 className="font-medium" data-id="element-1225">Evening</h4>
                <p className="text-gray-500 text-sm" data-id="element-1226">
                  Receive your reminder in the evening.
                </p>
              </div>
              <div className={`w-6 h-6 rounded-full ${timing === 'evening' ? 'bg-blue-500' : 'border border-gray-300'} flex items-center justify-center`} data-id="element-1227">
                {timing === 'evening' && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1228">
                    <path d="M20 6 9 17l-5-5" data-id="element-1229"></path>
                  </svg>}
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-1230">
          <h3 className="font-medium text-lg" data-id="element-1231">Tone</h3>
          <div className="flex space-x-3" data-id="element-1232">
            <button className={`flex-1 py-3 px-4 rounded-xl ${tone === 'gentle' ? 'bg-blue-500 text-white' : 'border border-gray-200'}`} onClick={() => setTone('gentle')} data-id="element-1233">
              Gentle
            </button>
            <button className={`flex-1 py-3 px-4 rounded-xl ${tone === 'neutral' ? 'bg-blue-500 text-white' : 'border border-gray-200'}`} onClick={() => setTone('neutral')} data-id="element-1234">
              Neutral
            </button>
            <button className={`flex-1 py-3 px-4 rounded-xl ${tone === 'motivating' ? 'bg-blue-500 text-white' : 'border border-gray-200'}`} onClick={() => setTone('motivating')} data-id="element-1235">
              Motivating
            </button>
          </div>
        </div>
        <div className="bg-gray-100 p-5 rounded-xl mt-6" data-id="element-1236">
          <h3 className="text-gray-700 font-medium mb-2" data-id="element-1237">Example</h3>
          <p className="text-gray-600" data-id="element-1238">
            {tone === 'gentle' && '"Just a friendly reminder to check in with your fitness goals today!"'}
            {tone === 'neutral' && '"Time to check in with your workout plan for today."'}
            {tone === 'motivating' && '"Let\'s crush those fitness goals today! Your future self will thank you!"'}
          </p>
        </div>
      </main>
      <div className="p-6" data-id="element-1239">
        <Button onClick={handleSaveChanges} variant="primary" fullWidth className="py-3" data-id="element-1240">
          Save Changes
        </Button>
      </div>
    </div>;
};